import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { IconButton } from "@mui/material";
import Slide from "@mui/material/Slide";

const TypeOfReports = (props) => {
  //Hooks
  const classes = useStyles();
  const navigation = useNavigate();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { siteConfig } = useSelector((state) => state.defs);

  return (
    <Box
      sx={{ height: "84vh", overflow: "hidden", mx: 4, width: "100%" }}
    >
      <Grid
        container
        sx={{
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
          <Grid item xs={3} sx={{ my: 1, cursor: "pointer" }}>
            <Box
              sx={{
                textAlign: "center",
                mx: 2,
                pt: 3,
             background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
                color: "#5f5600ff",
               
              }}
              onClick={() => {
                navigation("/Report/Assignments");
              }}
            >
              <img
                src={require("../../assets/report_2.png")}
                className={classes.image1}
              />
              <Typography
                sx={{ border: 1, mx: 6, borderColor: "#e2e2e2" }}
              ></Typography>
              <Typography className={classes.cardText}>
                Assignment <br />
                Reports
              </Typography>
              {/* <Box sx={{ textAlign: "right", py: 1, px: 1 }}>
                <IconButton
                  sx={{
                    backgroundColor: "#F5F7FF",
                   
                  }}
                >
                  <NavigateNextIcon
                    sx={{
                      color: "primary.main",
                     
                    }}
                  />
                </IconButton>
              </Box> */}
            </Box>
          </Grid>
        {(userInfo.rolesInfo.title.toLowerCase() === "staff" ||
          userInfo.rolesInfo.title.toLowerCase() === "trainer" ||
          userInfo.rolesInfo.title.toLowerCase() === "incharge" ||
          userInfo.rolesInfo.title.toLowerCase() === "admin") && (
            <Grid item xs={3} sx={{ my: 1, cursor: "pointer" }}>
              <Box
                sx={{
                  textAlign: "center",
                  mx: 2,
                  pt: 3,
               background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
                  color: "#5f5600ff",
                
                }}
                onClick={() => {
                  navigation("/Report/Learners");
                }}
              >
                <img
                  src={require("../../assets/report_2.png")}
                  className={classes.image1}
                />
                <Typography
                  sx={{ border: 1, mx: 6, borderColor: "#e2e2e2" }}
                ></Typography>
                <Typography className={classes.cardText}>
                  Learners <br />
                  Report
                </Typography>
                {/* <Box sx={{ textAlign: "right", py: 1, px: 1 }}>
                  <IconButton
                    sx={{
                      backgroundColor: "#F5F7FF",
                   
                    }}
                  >
                    <NavigateNextIcon
                      sx={{
                        color: "primary.main",
                      
                      }}
                    />
                  </IconButton>
                </Box> */}
              </Box>
            </Grid>

        )}
        {siteConfig.customer?.addOnInfo?.isSelfLearning && (

            <Grid item xs={3} sx={{ my: 1, cursor: "pointer" }}>
              <Box
                sx={{
                  textAlign: "center",
                  mx: 2,
                  pt: 3,
               background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
                  color: "#5f5600ff",
                 
                }}
                onClick={() => {
                  navigation("/Report/Progress");
                }}
              >
                <img
                  src={require("../../assets/report_2.png")}
                  className={classes.image1}
                />
                <Typography
                  sx={{ border: 1, mx: 6, borderColor: "#e2e2e2" }}
                ></Typography>
                <Typography className={classes.cardText}>
                  Learner Progress <br />
                  Reports
                </Typography>
                {/* <Box sx={{ textAlign: "right", py: 1, px: 1 }}>
                  <IconButton
                    sx={{
                      backgroundColor: "#F5F7FF",
                   
                    }}
                  >
                    <NavigateNextIcon
                      sx={{
                        color: "primary.main",
                       
                      }}
                    />
                  </IconButton>
                </Box> */}
              </Box>
            </Grid>
        )}
        {(userInfo.rolesInfo.title.toLowerCase() === "staff" ||
          userInfo.rolesInfo.title.toLowerCase() === "trainer" ||
          userInfo.rolesInfo.title.toLowerCase() === "incharge" ||
          userInfo.rolesInfo.title.toLowerCase() === "admin") && (
            <Grid item xs={3} sx={{ my: 1, cursor: "pointer" }}>
              <Box
                sx={{
                  textAlign: "center",
                  mx: 2,
                  pt: 3,
               background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
                  color: "#5f5600ff",
                
                }}
                onClick={() => {
                  navigation("/Report/Insight");
                }}
              >
                <img
                  src={require("../../assets/report_2.png")}
                  className={classes.image1}
                />
                <Typography
                  sx={{ border: 1, mx: 6, borderColor: "#e2e2e2" }}
                ></Typography>
                <Typography className={classes.cardText}>
                  Insights <br /> &nbsp;
                </Typography>
                {/* <Box sx={{ textAlign: "right", py: 1, px: 1 }}>
                  <IconButton
                    sx={{
                      backgroundColor: "#F5F7FF",
                     
                    }}
                  >
                    <NavigateNextIcon
                      sx={{
                        color: "primary.main",
                     
                      }}
                    />
                  </IconButton>
                </Box> */}
              </Box>
            </Grid>
        )}
        {userInfo.rolesInfo.title.toLowerCase() != "learner" && (
          <>
              <Grid item xs={3} sx={{ my: 1, cursor: "pointer" }}>
                <Box
                  sx={{
                    textAlign: "center",
                    mx: 2,
                    pt: 3,
                 background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
                    color: "#5f5600ff",
                  
                  }}
                  onClick={() => {
                    navigation("/Report/Trainers");
                  }}
                >
                  <img
                    src={require("../../assets/report_2.png")}
                    className={classes.image1}
                  />
                  <Typography
                    sx={{ border: 1, mx: 6, borderColor: "#e2e2e2" }}
                  ></Typography>
                  <Typography className={classes.cardText}>
                    Trainers <br />
                    Report
                  </Typography>
                  {/* <Box sx={{ textAlign: "right", py: 1, px: 1 }}>
                    <IconButton
                      sx={{
                        backgroundColor: "#F5F7FF",
                       
                      }}
                    >
                      <NavigateNextIcon
                        sx={{
                          color: "primary.main",
                         
                        }}
                      />
                    </IconButton>
                  </Box> */}
                </Box>
              </Grid>
              <Grid item xs={3} sx={{ my: 1, cursor: "pointer" }}>
                <Box
                  sx={{
                    textAlign: "center",
                    mx: 2,
                    pt: 3,
                 background: "linear-gradient(135deg, rgba(180,227,145,1) 0%,rgba(97,196,25,1) 50%,rgba(180,227,145,1) 100%);",
                    color: "#5f5600ff",
                  
                  }}
                  onClick={() => {
                    navigation("/Report/ClasswiseUsage");
                  }}
                >
                  <img
                    src={require("../../assets/report_2.png")}
                    className={classes.image1}
                  />
                  <Typography
                    sx={{ border: 1, mx: 6, borderColor: "#e2e2e2" }}
                  ></Typography>
                  <Typography className={classes.cardText}>
                    Course <br />
                    Progress
                  </Typography>
                  {/* <Box sx={{ textAlign: "right", py: 1, px: 1 }}>
                    <IconButton
                      sx={{
                        backgroundColor: "#F5F7FF",
                       
                      }}
                    >
                      <NavigateNextIcon
                        sx={{
                          color: "primary.main",
                        
                        }}
                      />
                    </IconButton>
                  </Box> */}
                </Box>
              </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  cardText: {
    fontWeight: "800",
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: "1.1rem",
    "@media (min-width: 1636px)": { fontSize: "1.8rem" },
  },
  image1: {
    width: "55%",
    "@media (min-width: 1636px)": { width: "50%" },
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default TypeOfReports;
